import Skeleton from "../../../../components/Skeleton/Skeleton";
import { Card } from "../../../../components/Card/Card";
import styles from "./InstrumentSkeleton.module.scss";
import useScreenSize from "../../../../hooks/useScreenSize";

const InstrumentSkeleton = () => {
  const { isMobile } = useScreenSize();
    
  const { cardHeaderTitle, item, compositionContainer, tooltipDiv } = styles;

  const mainLayoutClass = isMobile 
    ? "flex flex-col gap-5" 
    : "flex gap-5 items-stretch";
    
  const widthClass = isMobile ? "w-full" : "flex-1";

  return (
    <>
      {/* Header Skeleton */}
      <div className="mb-6 mt-8">
        <Skeleton width={isMobile ? "100%" : "300px"} height="2.5rem" borderRadius="0.5rem" />
      </div>

      {/* Section Skeleton */}
      <div className="my-4">
        <Skeleton width={isMobile ? "90%" : "60%"} height="2rem" borderRadius="0.5rem" />
      </div>
      <div className="mb-6">
        <Skeleton width={isMobile ? "80%" : "60%"} height="1.5rem" borderRadius="0.5rem" />
      </div>
      
      <div className={mainLayoutClass}>
        
        {/* Left Card Skeleton (w-full en mobile) */}
        <div className={widthClass}>
          <Card className="h-full">
            <div className="flex flex-col h-full">
              <div>
                {/* Header with Type and Tabs */}
                <div className="flex items-center gap-6 self-stretch justify-between">
                  <div className={cardHeaderTitle}>
                    <Skeleton
                      width="150px"
                      height="2rem"
                      borderRadius="0.5rem"
                      className="mt-2"
                    />
                  </div>
                  <Skeleton
                    width="100px"
                    height="2.5rem"
                    borderRadius="0.5rem"
                  />
                </div>

                {/* Variation Percentage Skeleton */}
                <Skeleton
                  width="120px"
                  height="1.5rem"
                  borderRadius="0.5rem"
                  className="mt-4"
                />

                {/* Details Grid Skeleton */}
                <div>
                  <div className="flex flex-col gap-6 mt-6">
                    {Array(4)
                      .fill(0)
                      .map((_, rowIndex) => (
                        <div key={rowIndex} className="grid grid-cols-2 gap-6">
                          {Array(2)
                            .fill(0)
                            .map((_, colIndex) => (
                              <div
                                key={colIndex}
                                className={`flex gap-3 items-start ${
                                  !isMobile && rowIndex !== 3 ? item : ""
                                }`}
                              >
                                <Skeleton
                                  width="1.5rem"
                                  height="1.5rem"
                                  borderRadius="0.25rem"
                                />
                                <div className="flex-1 w-full">
                                  <Skeleton
                                    width="80%"
                                    height="1rem"
                                    borderRadius="0.25rem"
                                  />
                                  <Skeleton
                                    width="100%"
                                    height="1rem"
                                    borderRadius="0.25rem"
                                    className="mt-2"
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      ))}
                  </div>
                </div>
              </div>

              {/* More Info Link Skeleton */}
              <div className="mt-auto pt-6">
                <Skeleton
                  width="200px"
                  height="1.5rem"
                  borderRadius="0.25rem"
                />
              </div>
            </div>
          </Card>
          
          {isMobile && (
            <div className="mt-5">
              <Skeleton width="100%" height="3rem" borderRadius="0.5rem" />
            </div>
          )}
        </div>

        {/* Right Column Skeleton (w-full en mobile) */}
        <div className={widthClass + " flex flex-col gap-5"}>
          
          {/* Variation Card Skeleton (Primer esqueleto de la columna derecha, se MANTIENE) */}
          <Card>
            <Skeleton width="100%" height="200px" borderRadius="0.5rem" />
          </Card>

          {!isMobile && (
            <Card>
              <div className={compositionContainer}>
                <Skeleton width="150px" height="1.5rem" borderRadius="0.25rem" />
                <div className={tooltipDiv}>
                  <Skeleton width="150px" height="1rem" borderRadius="0.25rem" />
                </div>
              </div>
              <div className="mt-6 flex flex-col">
                {Array(3)
                  .fill(0)
                  .map((_, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`grid grid-cols-2 gap-6 ${
                        rowIndex !== 2
                          ? "border-b border-[#EBEBEB] pb-5 mb-5"
                          : ""
                      }`}
                    >
                      {Array(2)
                        .fill(0)
                        .map((_, colIndex) => (
                          <div key={colIndex} className="flex items-center gap-4">
                            {!isMobile && colIndex > 0 && (
                              <div
                                style={{
                                  width: "0.0625rem",
                                  height: "2.375rem",
                                  background: "#EBEBEB",
                                }}
                              />
                            )}
                            <div className="w-[2.25rem] h-[2.25rem] flex-shrink-0">
                              <Skeleton
                                width="2.25rem"
                                height="2.25rem"
                                borderRadius="50%"
                              />
                            </div>
                            <div className="flex-1">
                              <Skeleton
                                width="50px"
                                height="1rem"
                                borderRadius="0.25rem"
                              />
                              <Skeleton
                                width="100%"
                                height="0.875rem"
                                borderRadius="0.25rem"
                                className="mt-1"
                              />
                            </div>
                          </div>
                        ))}
                    </div>
                  ))}
              </div>
            </Card>
          )}
        </div>
      </div>
    </>
  );
};

export default InstrumentSkeleton;